import React from "react";
import Text from "../../components/Text";
import { fontSizes } from "../../constants/constants";
import ViewItems from "../../components/ViewItems";
import ViewReverse from "../../components/ViewReverse";
import CustomDropdown from "../../components/CustomDropdown";
import { monthsOptions, years } from "../../config/config";
import { ReactSVG } from "react-svg";
import icons from "../../constants/icons";
import accountStatementFunctional from "./index.function";
import { rowReverseStylesm } from "../../utils/styles";
import { downloadBase64File } from "../../utils/functions";
import TermsModal from "../../components/TermsModal";
import images from "../../constants/images";

const AccountStatement = () => {
  const {
    isArabic,
    TextWeight,
    recipient,
    selectedMonth,
    emailModal,
    selectedYear,
    accountReport,
    setSelectedYear,
    getContentKey,
    setRecipient,
    setSelectedMonth,
    toogleEmailModal,
    handleViewReport,
    isView,
    setIsView,
    onSendEmail,
  } = accountStatementFunctional();

  return (
    <div>
      <Text
        text={getContentKey("reports")}
        size={fontSizes.h24}
        weight={TextWeight.bold}
        color="text-primary"
      />
      <ViewItems className={"mb-28"}>
        <ViewReverse
          className={`border border-grey px-5 flex-col py-3 rounded w-full lg:w-3/4 mt-5 gap-4 justify-between pb-14 ${rowReverseStylesm(
            isArabic
          )}`}
        >
          <ViewItems className={"w-full sm:w-2/3 justify-between"}>
            <div className="w-full">
              <Text
                text={getContentKey("account_statement")}
                size={fontSizes.h14}
                className={"mb-3"}
              />
              <CustomDropdown
              
                label={getContentKey("select_statement_month")}
                onSelect={(val) => {
                  setSelectedMonth(val);
                  setSelectedYear(null);
                }}
                options={monthsOptions(getContentKey)}
                selectedValue={selectedMonth}
                isBorder
                valueKey={"label"}
              />
              <CustomDropdown
                label={getContentKey("select_month")}
                onSelect={(val) => {
                  setSelectedYear(val);
                  handleViewReport(val);
                }}
                options={years}
                selectedValue={selectedYear}
                isBorder
                valueKey={"year"}
                className={"mt-3"}
              />
            </div>

            <ViewReverse className={"w-full justify-end mt-4"}>
              <Text
                text={getContentKey("view")}
                size={fontSizes.h14}
                color="text-primary"
                className={"cursor-pointer"}
                onClick={() => setIsView(true)}
                isDisabled={!accountReport?.report}
              />
              <div className="h-5 w-[1.5px] bg-primary mx-2" />
              <Text
                text={getContentKey("download")}
                size={fontSizes.h14}
                color="text-primary"
                className={"cursor-pointer"}
                isDisabled={!accountReport?.report}
                onClick={() =>
                  downloadBase64File({
                    base64Data: accountReport?.report,
                    fileName: accountReport?.displayName,
                  })
                }
              />
              <div className="h-5 w-[1.5px] bg-primary mx-2" />
              <Text
                text={getContentKey("email")}
                size={fontSizes.h14}
                color="text-primary"
                onClick={onSendEmail}
                className={"cursor-pointer"}
                isDisabled={!accountReport?.report}
              />
            </ViewReverse>
          </ViewItems>

          <ViewItems>
            {
              accountReport?.report ?
              <img src={images.report} className="w-56" />
              :
              <div className="w-full mt-4 sm:me-4 flex justify-center items-center bg-light-grey p-10 rounded">
                <ReactSVG src={icons.pdf} />
              </div>
            }
            <Text text={accountReport?.displayName} className={"mt-2"} />
          </ViewItems>
        </ViewReverse>

      </ViewItems>

      <TermsModal isOpen={isView} onClose={() => setIsView(false)} title={accountReport?.displayName} src={accountReport?.report} />
    </div>
  );
};

export default AccountStatement;
